import { DocumentTextIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "react-query";
import { useRecoilState } from "recoil";
import CancelButton from "../../../../components/CancelButton";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import SubmitHookForm from "../../../../components/SubmitHookForm";
import TextAreaHookForm from "../../../../components/TextAreaHookForm";
import { toast } from "../../../../components/toastNotification";
import {
  resetSubmoduleDataState,
  showScriptsSubmoduleState,
} from "../atoms/atom";
import { useEditScript } from "../hooks/useEditScript";

export const SciptForm = ({
  setIsEdit,
  scriptContent,
  rowForEdit,
  refetchScript,
  setIsView,
  isView,
}) => {
  const [newData, setNewData] = useState([]);
  const [saveModal, setSaveModal] = useState(false);
  const [isShowSubmodule, setIsShowSubmodule] = useRecoilState(
    showScriptsSubmoduleState
  );
  const [resetScriptDatas, setResetScriptDatas] = useRecoilState(
    resetSubmoduleDataState
  );

  const {
    mutate: editScript,
    isSuccess: editScriptSuccess,
    data: editScriptData,
    reset: resetScriptData,
  } = useEditScript();

  const { register, handleSubmit, setValue } = useForm();

  const onSubmit = (data) => {
    const oldScriptContent = JSON.stringify(scriptContent);
    const newScriptContent = JSON.stringify(data.script);
    if (oldScriptContent === newScriptContent) {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
    } else {
      setNewData({ ...data });
      setSaveModal(true);
    }
  };

  const handleSave = () => {
    editScript(newData);
  };

  const onClose = () => {
    setSaveModal(false);
    setIsEdit(false);
    setIsShowSubmodule(false);
    setResetScriptDatas(true);
  };

  useEffect(() => {
    setValue("script", scriptContent);
    setValue("id", rowForEdit.id);
    setValue("path", rowForEdit.path);
  }, []);

  if (editScriptSuccess && editScriptData) {
    if (editScriptData === 200) {
      toast.fire("Success", "Script updated successfully.", "success");
      refetchScript();
      onClose();
    }
    resetScriptData();
  }

  return (
    <div>
      <div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-row  justify-between items-center text-quinary font-bold font-sans text-lg pb-1 mt-2">
            <div className="font-bold text-primary text-base">SCRIPT</div>
            <div className="flex justify-between gap-2">
              {!isView && <SubmitHookForm type="submit" buttonText={"Save"} />}
              <CancelButton
                type="button"
                onClick={() => {
                  setIsEdit(false);
                  setIsView(false);
                }}
              />
            </div>
          </div>

          <div className="bg-bgDB py-4 space-y-4 border-gray-700">
            <TextAreaHookForm
              secondDiv="grid grid-cols-1"
              name="script"
              label=""
              rows="12"
              type="text"
              placeholder=""
              className="text-lg sm:text-lg border-2 border-gray-200"
              register={register("script", {})}
            />
          </div>
        </form>
      </div>
      <ConfirmBoxModal
        ModalTitle={"Update script"}
        qConfirmation={`Are you sure you want to update this script?`}
        isOpen={saveModal}
        onClose={() => {
          onClose();
        }}
        onClickFunction={() => {
          handleSave();
        }}
      />
    </div>
  );
};
